import { useEffect, useState } from 'react';
import { MEDIA_QUERY_WIDTH } from '../styles';

export const useMediaQuery = (
  queryToMatch = `screen and (max-width: ${MEDIA_QUERY_WIDTH}px)`
) => {
  const [isMobile, setIsMobile] = useState(false);
  const { matchMedia } = window || {};
  const mediaQuery = matchMedia && matchMedia(queryToMatch);

  useEffect(() => {
    if (!mediaQuery) {
      return;
    }

    const handleResize = () => setIsMobile(!!mediaQuery?.matches);
    handleResize();

    mediaQuery.addListener(handleResize);
    return () => mediaQuery?.removeListener(handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isMobile;
};

export default useMediaQuery;
